import { render, staticRenderFns } from "./bullScrotalCircumferenceMonthly.vue?vue&type=template&id=36485e58&scoped=true&"
import script from "./bullScrotalCircumferenceMonthly.vue?vue&type=script&lang=js&"
export * from "./bullScrotalCircumferenceMonthly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36485e58",
  null
  
)

export default component.exports